import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'pools', pathMatch: 'full' },

  { path: 'pools', loadChildren: () => import('@cbui/modules/pools/pools.routes').then(m => m.default) },
  { path: 'freeplay', loadChildren: () => import('@cbui/modules/freeplay/freeplay.routes').then(m => m.default) },
  { path: 'syndicates', loadChildren: () => import('@cbui/modules/syndicates/syndicates.routes').then(m => m.default) },
  { path: 'tickets', loadChildren: () => import('@cbui/modules/tickets/tickets.routes').then(m => m.default) },
  { path: 'results', loadChildren: () => import('@cbui/modules/results/results.routes').then(m => m.default) },
  { path: 'help', loadChildren: () => import('@cbui/modules/help/help.routes').then(m => m.default) },
  { path: 'errors', loadChildren: () => import('@cbui/modules/errors/errors.routes').then(m => m.default) },

  { path: '**', redirectTo: '/' }
];
